export default __webpack_public_path__ + "static/media/UBMe Appstore.5af8245a.png";